import React from "react";

export default function OnuiEcoVillage() {
  // 모바일/웹 공식 홈페이지 실시간 연결 핸들러
  const handleBooking = (e) => {
    e.preventDefault();
    window.open("http://m.onui.org", "_blank", "noopener,noreferrer");
  };

  // 🌟 오누이 마을 주변 관광지 데이터 배열
  const attractions = [
    {
      name: "오서산 도립공원",
      image:
        "https://scontent-yyz1-1.cdninstagram.com/v/t39.30808-6/675717550_1372262554935565_5490810477019428054_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=105&ig_cache_key=Mzg3OTgyOTExMjYyMjE0MzEwNw%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6IkNBUk9VU0VMX0lURU0ueHBpZHMuMTA4MC5zZHIucmVndWxhcl9waG90by5DMyJ9&_nc_ohc=01uvOuwVhlsQ7kNvwFAUsNU&_nc_oc=Adplpvo_KpTwr0M9p5NMYYq1AbiRG7L7ZP9hNb7o-jwIeraH6O8FTZvSh0efsf2N_l4&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-yyz1-1.cdninstagram.com&_nc_gid=H5GmzzFXSyZI_4QbSzIFBA&_nc_ss=7a22e&oh=00_Af5D8iAM0H4PxGWwHBUeyr84BzfNbvCJckiwx2he1ZBZcQ&oe=6A13FB3C",
      desc: "충남 서해안의 최고봉으로 억새 군락과 탁 트인 서해 전경이 아름다운 명소"
    },
    {
      name: "홍주읍성",
      image:
        "https://ojsfile.ohmynews.com/STD_IMG_FILE/2023/0111/IE003100483_STD.jpeg",
      desc: "홍성의 역사를 품고 있는 고즈넉한 성곽길로 야경과 산책에 최고의 장소"
    },
    {
      name: "장곡천 생태산책로",
      image:
        "https://cdn.goodmorningcc.com/news/photo/202112/262206_279837_1458.jpg",
      desc: "오누이 마을을 감싸 안고 흐르는 청정 냇가를 따라 걷는 평온한 시골길"
    }
  ];

  return (
    <div style={styles.fcContainer}>
      {/* 1. FarmCiti 검증 규격 멀티 모자이크 갤러리 그리드 영역 */}
      <div style={styles.galleryGrid}>
        <div style={styles.galleryTable}>
          <div style={styles.galleryMainCell}>
            <div
              style={{
                ...styles.imgPlaceholder,
                backgroundImage:
                  'linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.4)), url("https://cdn.welfarehello.com/naver-blog/production/hsgstory/2023-09/223214518948/hsgstory_223214518948_1.jpg?f=webp&q=80&w=800")'
              }}
            >
              <div style={styles.imgOverlayText}>대표 전경</div>
            </div>
          </div>
          <div style={styles.gallerySubCell}>
            <div style={styles.subGridTable}>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://lh3.googleusercontent.com/proxy/bnqecbqD_92oLvFDflcKeybRozzg2qsdHd-dDpfXYNiNPwJjhxzSn9tiatSTn4v8frh5tMgmi5fY2pjQlo7IrsNVEKJKfpKzT-dhcxSg2wW-8cv_WQQLxaz-Lvnmpm27ekqjrYRc")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://cdn.welfarehello.com/naver-blog/production/hsgstory/2023-09/223214518948/hsgstory_223214518948_4.jpg")'
                    }}
                  />
                </div>
              </div>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOgMNle7dnqrBfIg9dstBivWUJKOqloBcUbg&s")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQooI2QECPnnUddxt-7z4crm8VrG-n6g7Ysw&s")'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2. 메인 콘텐츠 / 사이드바 가로 배열 양분할 스트림 */}
      <div style={styles.mainLayoutWrapper}>
        {/* LEFT COLUMN: 핵심 마을 소개 및 방문 전 유의사항 타임라인 */}
        <div style={styles.leftContentStream}>
          <div style={styles.farmTitleHeader}>
            <h1
              style={{
                fontSize: "32px",
                fontWeight: "800",
                color: "#1a202c",
                marginBottom: "8px"
              }}
            >
              오누이 친환경 마을
            </h1>
            <div
              style={{
                fontSize: "18px",
                color: "#718096",
                marginBottom: "12px"
              }}
            >
              Onui Eco Village
            </div>
            <div style={{ fontSize: "14px", color: "#4a5568" }}>
              📍 대한민국 충청남도 홍성군 장곡면 홍남동로473번길 79-22
            </div>
          </div>

          <div style={styles.sectionTitleSub}>농장 한눈에 보기</div>
          <div style={styles.featuresBadgeCloud}>
            {[
              "🌿 친환경 농업 (Eco Farming)",
              "🏡 마을 공동체 (Community)",
              "🍳 음식 체험 (Food Workshop)",
              "📚 교육 활동 (Educational)",
              "🛌 농촌 숙박 (Farmstays)",
              "🤝 도농 교류 (Urban-Rural Exchange)"
            ].map((tag, idx) => (
              <span key={idx} style={styles.fcBadge}>
                {tag}
              </span>
            ))}
          </div>

          <div style={{ marginBottom: "40px" }}>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "16px"
              }}
            >
              여행 정보
            </h3>
            <div
              style={{
                fontSize: "16px",
                color: "#4a5568",
                textAlign: "justify",
                lineHeight: "1.7"
              }}
            >
              <p>
                충남 홍성군 장곡면에 위치한 오누이친환경마을협동조합은 2011년
                청년 농부 세 명이 씨앗을 뿌린 곳에서 시작해, 2016년 오누이권역
                개발사업을 통해 마을 공동체 거점 공간으로 성장한 친환경 농촌
                마을입니다. 유기재배 쌈채소와 벼를 키우는 농장, 공동 학습과 문화
                활동이 이루어지는 커뮤니티센터, 따뜻한 밥 한 끼를 나누는
                행복부엌, 그리고 도시와 농촌을 잇는 다양한 교육 활동이 이 공간
                안에서 함께 숨쉬고 있습니다. 농사를 배우고 싶은 청년, 농촌의
                삶이 궁금한 가족, 공동체 활동에 함께하고 싶은 누구든 환영하는
                열린 공간입니다.
              </p>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #edf2f7", paddingTop: "32px" }}>
            <div style={styles.sectionTitleSub}>농장 키포인트</div>
            <div style={{ marginBottom: "40px" }}>
              {[
                {
                  title: "🌾 유기재배 농장, 직접 보고 배우는 살아있는 교실",
                  body: "시설하우스 8동에서 자라는 쌈채소부터 2,000평 논의 벼까지, 청년 농부들이 직접 일구는 유기농 농장을 눈앞에서 만나보세요. 농사의 첫 걸음이 궁금한 분이라면 더욱 특별한 경험이 됩니다."
                },
                {
                  title: "🍳 행복부엌에서 나누는 따뜻한 밥 한 끼",
                  body: "오누이만의 음식 체험 공간, 행복부엌에서 직접 요리하고 함께 밥상을 나눠보세요. 식단에 따라 체험비가 달라지니 방문 전 미리 문의하시면 더욱 알차게 준비할 수 있습니다."
                },
                {
                  title: "📚 마을 도서관과 소모임 공간, 쉬어가는 여유",
                  body: "다목적회관 안의 마을 도서관에서 잠시 책을 펼쳐보거나, 어린이 도서관 코너에서 아이와 함께 여유로운 시간을 보내보세요. 학습 모임과 문화 활동을 위한 대관도 가능합니다."
                },
                {
                  title: "🛌 예절교육관에서의 하룻밤, 마을에 스며드는 시간",
                  body: "큰방·중간방·작은방 총 5개 객실을 갖춘 숙박시설에서 하룻밤 머물며 장곡면의 고요한 밤을 즐겨보세요. 단체·가족 모두 이용 가능하며, 숙박 요금은 전화로 문의 주세요."
                },
                {
                  title: "📞 대관·숙박·체험 모두 사전 문의 필수",
                  body: "원활한 프로그램 운영을 위해 방문 전 반드시 041-642-9990(월~금 9:00~18:00)으로 연락해 일정을 조율해 주세요."
                }
              ].map((reminder, idx) => (
                <div key={idx} style={styles.reminderRowItem}>
                  <span style={styles.reminderCardHeader}>
                    {reminder.title}
                  </span>
                  <span style={styles.reminderCardBody}>{reminder.body}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 🌟 [신규 추가] 오누이 마을 주변 관광지 레이아웃 영역 */}
          <div
            style={{
              borderTop: "1px solid #edf2f7",
              paddingTop: "32px",
              marginBottom: "24px"
            }}
          >
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "20px"
              }}
            >
              주변 관광지
            </h3>
            <div style={styles.attractionsGrid}>
              {attractions.map((place, idx) => (
                <div key={idx} style={styles.attractionCard}>
                  <div
                    style={{
                      ...styles.attractionImg,
                      backgroundImage: `url("${place.image}")`
                    }}
                  />
                  <div style={styles.attractionInfo}>
                    <h4 style={styles.attractionName}>{place.name}</h4>
                    <p style={styles.attractionDesc}>{place.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN: 에센셜 사이드바 정보 스택 & 구글맵 & 실시간 날씨 위젯 */}
        <div style={styles.rightSidebarStream}>
          <div style={styles.stickyInfoCard}>
            <div style={styles.sidebarWidgetTitle}>농장 기본 정보</div>

            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>주소 (Address)</div>
              <div style={styles.essentialsValue}>
                대한민국 충청남도 홍성군 장곡면 홍남동로473번길 79-22
              </div>
            </div>

            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>문의전화 (Phone)</div>
              <div style={styles.essentialsValue}>
                <a
                  href="tel:041-642-9990"
                  style={{
                    color: "#1a4331",
                    fontWeight: "700",
                    textDecoration: "underline"
                  }}
                >
                  041-642-9990
                </a>
              </div>
            </div>

            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>홈페이지 (Website)</div>
              <div style={styles.essentialsValue}>
                <a
                  href="http://m.onui.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1a4331",
                    textDecoration: "underline",
                    fontWeight: "600"
                  }}
                >
                  http://m.onui.org
                </a>
              </div>
            </div>

            <div
              style={{
                ...styles.essentialsRow,
                marginTop: "24px",
                borderTop: "1px solid #edf2f7",
                paddingTop: "16px"
              }}
            >
              <div style={styles.essentialsLabel}>Hours (상담 가능 시간)</div>
              <div style={{ ...styles.essentialsValue, fontWeight: "600" }}>
                월요일 ~ 금요일 (주말 사전 예약제)
              </div>
              <div
                style={{
                  color: "#1a4331",
                  fontSize: "16px",
                  fontWeight: "800",
                  marginTop: "2px"
                }}
              >
                09:00 AM - 06:00 PM
              </div>
            </div>

            <div style={styles.bookingStatusBox}>
              <div
                style={{
                  fontSize: "13px",
                  color: "#166534",
                  lineHeight: "1.5"
                }}
              >
                <strong>✅ 모바일 채널 실시간 연결</strong>
                <br />
                해당 마을은 협동조합 공식 모바일 연동 슬롯이 완비되어 클릭 시
                공식 웹으로 안전하게 이동합니다.
              </div>
            </div>

            <button onClick={handleBooking} style={styles.fcPrimaryBtnActive}>
              공식 홈페이지 방문 →
            </button>
          </div>

          <div style={{ ...styles.sidebarWidgetTitle, marginTop: "32px" }}>
            위치 및 날씨 정보
          </div>
          <div>
            <div style={styles.mapContainerBox}>
              <iframe
                title="Google Map Onui Safe"
                src="https://maps.google.com/maps?q=%EC%B6%A9%EB%82%A8%20%ED%99%8D%EC%84%B1%EA%B5%B0%20%EC%9E%A5%EA%B3%A1%EB%A9%B4%20%ED%99%8D%EB%82%A8%EB%8F%99%EB%A1%9C473%EB%B2%88%EA%B8%B8%2079-22&t=&z=15&ie=UTF8&iwloc=&output=embed"
                style={styles.mapIframeStyle}
                allowFullScreen=""
                loading="lazy"
              />
            </div>

            <div style={styles.weatherWidgetContainer}>
              <div style={styles.weatherMainRow}>
                <div style={styles.weatherIconAnim}>☀️</div>
                <div>
                  <div style={styles.weatherTempText}>19.2°C</div>
                  <div style={styles.weatherStatusText}>
                    실시간 기상: 맑음 (Clean Air)
                  </div>
                </div>
              </div>
              <div style={styles.weatherDetailGrid}>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>습도</span>
                  <span style={styles.weatherDetailValue}>42%</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>풍속</span>
                  <span style={styles.weatherDetailValue}>1.8 m/s</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>미세먼지</span>
                  <span
                    style={{ ...styles.weatherDetailValue, color: "#2FA322" }}
                  >
                    좋음 (12㎛)
                  </span>
                </div>
              </div>
              <div style={styles.weatherUpdateFooter}>
                홍성군 기상대 실시간 동네예보 바인딩 완료
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  fcContainer: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "24px 40px",
    backgroundColor: "#fcfcf9"
  },
  galleryGrid: {
    display: "block",
    width: "100%",
    marginBottom: "32px",
    borderRadius: "16px",
    overflow: "hidden"
  },
  galleryTable: {
    display: "flex",
    width: "100%",
    minHeight: "60vh",
    gap: "8px"
  },
  galleryMainCell: { flex: 1 },
  gallerySubCell: { flex: 1 },
  subGridTable: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "8px"
  },
  subGridRow: { display: "flex", flex: 1, gap: "8px" },
  subGridItem: { flex: 1 },
  imgPlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#e2e8f0",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    minHeight: "210px",
    borderRadius: "8px"
  },
  imgOverlayText: {
    position: "absolute",
    bottom: "16px",
    left: "16px",
    background: "rgba(0, 0, 0, 0.6)",
    color: "#ffffff",
    padding: "6px 12px",
    fontSize: "12px",
    borderRadius: "4px"
  },
  mainLayoutWrapper: {
    display: "flex",
    width: "100%",
    gap: "48px",
    marginTop: "20px"
  },
  leftContentStream: { flex: 1.8 },
  rightSidebarStream: { flex: 1, minWidth: "320px" },
  farmTitleHeader: {
    marginBottom: "24px",
    borderBottom: "1px solid #2FA322",
    paddingBottom: "24px"
  },
  sectionTitleSub: {
    fontSize: "16px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#718096",
    marginBottom: "16px",
    fontWeight: "700"
  },
  featuresBadgeCloud: { display: "block", marginBottom: "36px" },
  fcBadge: {
    display: "inline-block",
    backgroundColor: "#f0fdf4",
    color: "#166534",
    padding: "8px 16px",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "600",
    marginRight: "8px",
    marginBottom: "8px",
    border: "1px solid #bbf7d0"
  },
  reminderRowItem: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column"
  },
  reminderCardHeader: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1a4331",
    marginBottom: "8px"
  },
  reminderCardBody: { fontSize: "14px", color: "#4a5568" },
  stickyInfoCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "28px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)"
  },
  sidebarWidgetTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "20px",
    borderBottom: "2px solid #1a4331",
    paddingBottom: "8px"
  },
  essentialsRow: { marginBottom: "16px" },
  essentialsLabel: {
    fontSize: "12px",
    fontWeight: "400",
    color: "#a0aec0",
    textTransform: "uppercase",
    marginBottom: "4px"
  },
  essentialsValue: { fontSize: "15px", color: "#2d3748", fontWeight: "500" },
  bookingStatusBox: {
    backgroundColor: "#f0fdf4",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "20px",
    borderLeft: "4px solid #166534"
  },
  fcPrimaryBtnActive: {
    display: "block",
    width: "100%",
    backgroundColor: "#1a4331",
    color: "#ffffff",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "16px",
    marginTop: "16px",
    cursor: "pointer",
    textAlign: "center",
    transition: "background 0.2s ease"
  },
  mapContainerBox: {
    width: "100%",
    height: "240px",
    borderRadius: "12px",
    overflow: "hidden",
    marginBottom: "16px",
    border: "1px solid #e2e8f0"
  },
  mapIframeStyle: { border: 0, width: "100%", height: "100%" },
  weatherWidgetContainer: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    textAlign: "left",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.02)",
    marginBottom: "16px"
  },
  weatherMainRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
    borderBottom: "1px solid #f1f3f5",
    paddingBottom: "14px"
  },
  weatherIconAnim: {
    fontSize: "36px",
    lineHeight: "1"
  },
  weatherTempText: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#1a202c",
    lineHeight: "1.2"
  },
  weatherStatusText: {
    fontSize: "13px",
    color: "#718096",
    fontWeight: "500",
    marginTop: "2px"
  },
  weatherDetailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
    textAlign: "center"
  },
  weatherDetailItem: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f8f9fa",
    padding: "8px 4px",
    borderRadius: "6px"
  },
  weatherDetailLabel: {
    fontSize: "11px",
    color: "#a0aec0",
    fontWeight: "600",
    marginBottom: "2px"
  },
  weatherDetailValue: {
    fontSize: "13px",
    color: "#2d3748",
    fontWeight: "700"
  },
  weatherUpdateFooter: {
    fontSize: "10px",
    color: "#cbd5e0",
    textAlign: "right",
    marginTop: "12px",
    fontWeight: "500"
  },

  // 🌟 주변 관광지 전용 스타일 규격
  attractionsGrid: {
    display: "flex",
    gap: "16px",
    width: "100%",
    boxSizing: "border-box"
  },
  attractionCard: {
    flex: 1,
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    display: "flex",
    flexDirection: "column"
  },
  attractionImg: {
    width: "100%",
    height: "140px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "#e2e8f0"
  },
  attractionInfo: {
    padding: "12px"
  },
  attractionName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "4px"
  },
  attractionDesc: {
    fontSize: "12px",
    color: "#718096",
    lineHeight: "1.4",
    margin: 0
  }
};
